import React from 'react'
import PropTypes from 'prop-types'

import styles from './../style/Cards1.module.scss'

import { Container, Image } from 'react-bootstrap'

import WhiteBlockTitle from './WhiteBlockTitle'

class Cards1 extends React.Component {
  
  formatSlideNumber = (index) => {
    // Добавляем ведущий ноль для чисел меньше 10
    return `[${index < 9 ? '0' + (index + 1) : index + 1}]`
  }

  render() {

    const { list, title, rtext, img1, img2 } = this.props

    return (
      <section className={`${styles.section} ${styles.top}`}>
        <Container>
          {title != `` &&
            <WhiteBlockTitle
              title={title}
              text={rtext}
              className={styles.title}
            />
          }
          <div className={`${styles.list} ${styles[`grid-4`]}`}>
            <div className={styles.images_block}>
              <Image src={img1} width={146} height={130} alt={`${title} - 1`} />
              <Image src={img2} width={146} height={130} alt={`${title} - 2`} />
            </div>
            {list.map( ( elm, k ) => (
              <div className={`${styles.block} ${styles[`bg-2`]} ${styles[`h-130`]}`}>
                <div className={styles.b_title_2}>
                  <div className={styles.b_icon}>
                    <Image src={elm?.icon} width={21} height={21} alt={elm?.name} />
                  </div>
                  <div className={styles.b_title_sep} />
                  <div>{this.formatSlideNumber(k)}</div>
                </div>
                <div className={`${styles.b_title_t_2} mb-0`} dangerouslySetInnerHTML={{__html: elm?.name}} />
              </div>
            ))}
          </div>
        </Container>
      </section>
    )
  }
}

Cards1.propTypes = {
  list: PropTypes.array,
  title: PropTypes.string,
  rtext: PropTypes.string,
  img1: PropTypes.string,
  img2: PropTypes.string
}

Cards1.defaultProps = {
  list: [],
  title: ``,
  rtext: ``,
  img1: ``,
  img2: ``
}

export default Cards1